<script setup lang="ts">
import { useTranslate } from "@/composables/useTranslate";
import { Worker } from "@/types";
import { defineProps } from "vue";

const { t } = useTranslate();

defineProps<Props>();
type Props = {
  workers: Worker[];
};
</script>

<template>
  <div class="flex flex-col overflow-y-hidden gap-2">
    <!-- Header -->
    <div
      class="w-full h-[41px] px-2 rounded-primary-radius bg-[#E5E4E2] grid grid-cols-3 gap-3 lg:gap-0 items-center"
    >
      <div class="flex items-center">
        <span
          class="text-[#393840] text-xs font-semibold leading-[17px] tracking-[0.01rem]"
          >{{ t("installers.table_column_name") }}</span
        >
      </div>
      <div class="flex items-center">
        <span
          class="text-[#393840] text-xs font-semibold leading-[17px] tracking-[0.01rem]"
          >{{ t("installers.table_column_email") }}</span
        >
      </div>
      <div class="flex items-center">
        <span
          class="text-[#393840] text-xs font-semibold leading-[17px] tracking-[0.01rem]"
          >{{ t("installers.table_column_role") }}</span
        >
      </div>
    </div>
    <!-- Content -->
    <div
      class="flex flex-col h-[calc(100%-41px)] overflow-y-auto w-full min-w-[500px] xl:min-w-[900px]"
      v-if="workers && workers.length > 0"
    >
      <div class="w-full h-full overflow-y-auto flex flex-col gap-2">
        <RouterLink
          :to="`/installers/${worker.id}`"
          v-for="worker in workers"
          :key="worker.id"
          class="w-full min-h-[41px] rounded-primary-radius px-2 bg-white grid grid-cols-3 gap-3 lg:gap-0 items-center"
        >
          <div class="flex items-center">
            <span
              class="text-primary-text-color text-sm font-normal leading-[20px] underline cursor-pointer"
              >{{ worker.fullname ? worker.fullname : "-" }}</span
            >
          </div>
          <div class="flex items-center">
            <span
              class="text-primary-text-color text-sm font-normal leading-[20px] break-all"
              >{{ worker.email ? worker.email : "-" }}</span
            >
          </div>
          <div class="flex items-center">
            <span
              class="text-primary-text-color text-sm font-normal leading-[20px]"
              >{{ worker.role ? worker.role : "-" }}</span
            >
          </div>
        </RouterLink>
      </div>
    </div>
    <div
      class="w-full flex items-center justify-center mt-10 text-primary-text-color text-base"
      v-else
    >
      {{ t("installers.no_results_found") }}
    </div>
  </div>
</template>
